import {Header} from '../../../container';
import Head from 'next/head';
import axios from 'axios';
import {parseLocationInfo} from '../../../helpers/utils';
import LocationContent from '../../../container/LocationContent';

const LocationPage = ({location, featuredItems, storeCode}) => {
  return (
    <>
      <Head>
        <title>{location.title}</title>
        {location.profile && location.profile.description &&
              <meta
                name='description'
                content={location.profile.description} />}
      </Head>
      <Header />
      <LocationContent
        locationInfo={location}
        featuredItems={featuredItems}
        storeCode={storeCode}
      />
    </>
  );
};

/**
 * Get API Response every time use load page
 * @param {object} context
 * @return {Promise<{}>}
 */
export async function getServerSideProps(context) {
  const {params} = context;
  const storeCode = params.storeCode;

  try {
    const API_V1 = process.env.NEXT_PUBLIC_API_V1;
    const getByStoreCodeUrl = API_V1 + `locations/store-code/${storeCode}`;
    const locationResp = await axios(getByStoreCodeUrl);
    const location = locationResp.data;
    const getLocationUrl = API_V1 +
        `locations/${location.PK.replace('LOCATION#', '')}`;
    const detailedLocationResp = await axios(getLocationUrl);
    const detailedLocation = detailedLocationResp.data;

    const parsedInfo = parseLocationInfo(detailedLocation);
    const parsedLocation = {
      ...detailedLocation,
      ...parsedInfo,
    };
    const featuredItemsResp = await axios(API_V1 +
        'menu/tags/6b1f7a77-fd9d-4320-88d2-2743039393fe/items');
    const featuredItems = featuredItemsResp.data;

    if (!location || !location.isActive) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        storeCode,
        location: parsedLocation,
        featuredItems,
      }, // will be passed to the page component as props
    };
  } catch (e) {
    console.error('Error: ' + e);
    return {
      notFound: true,
    };
  }
}

export default LocationPage;
